import { IPromoSearchItemSchema } from '../../repositories/newbuilding-promos/entities/promo_search_result/PromoSearchItemSchema';
import { IPromoItem } from '../../types/promos/promos';

export const mapPromosPreview = (promo: IPromoSearchItemSchema): IPromoItem => {
  return {
    activeDateToText: promo.activeDateToText,
    // @ts-expect-error TODO: Убрать директиву в CD-203174
    labels: promo.labels,
    newbuildingCountText: promo.newbuildingCountText,
    // @ts-expect-error TODO: Убрать директиву в CD-203174
    newbuildingIds: promo.newbuildingIds,
    promoName: promo.promoName,
    // @ts-expect-error TODO: Убрать директиву в CD-203174
    promoProps: promo.promoProps,
    promoTypeText: promo.promoTypeText,
    providerLogo: promo.providerLogo,
    providerName: promo.providerName,
  };
};
